import styled, { keyframes } from 'styled-components';
import Icon from '../Icon';
import Button from '../Button';
var slideInToast = /*#__PURE__*/keyframes(["0%{transform:translateX(200px);opacity:0;max-height:0;}35%{opacity:0.5;max-height:300px;}100%{transform:translateX(0);opacity:1;max-height:300px;}"]);
var fadeOutToast = /*#__PURE__*/keyframes(["0%{opacity:1;max-height:300px;}65%{max-height:300px;opacity:0;}100%{opacity:0;max-height:0;margin-bottom:0;border:0;}"]);
export var ToastWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "style__ToastWrapper",
  componentId: "sc-1vrc5ye-0"
})(["cursor:", ";animation-name:", ";animation-duration:1s;animation-timing-function:ease-in-out;animation-fill-mode:forwards;position:relative;background-color:", ";border-radius:", ";border:1px solid transparent;border-color:", ";display:block;color:", ";box-shadow:0 ", " ", " 0 rgba(0,0,0,0.08);margin-bottom:", ";font-family:", ";font-size:", ";width:400px;max-width:100%;"], function (props) {
  return props.onClick ? 'pointer' : 'default';
}, function (props) {
  return props.exiting ? fadeOutToast : slideInToast;
}, function (_ref) {
  var theme = _ref.theme;
  return theme.colors.background.white;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.spacing.sp16;
}, function (_ref3) {
  var alert = _ref3.alert,
    theme = _ref3.theme;
  if (alert === 'success') return theme.colors.border.success;
  if (alert === 'warning') return theme.colors.border.warning;
  if (alert === 'error') return theme.colors.border.alert;
  return theme.colors.border.info; // Defaults to info
}, function (_ref4) {
  var alert = _ref4.alert,
    theme = _ref4.theme;
  return alert === 'error' ? theme.colors.signal.alert : 'inherit';
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.spacing.sp4;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.spacing.sp4;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.spacing.sp8;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.fonts.fontFamily.primary;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.fonts.fontSize.ft16;
});
export var StyledCheckIcon = /*#__PURE__*/styled(Icon).withConfig({
  displayName: "style__StyledCheckIcon",
  componentId: "sc-1vrc5ye-1"
})(["position:absolute;left:16px;height:", ";width:", ";top:22px;fill:", ";"], function (_ref10) {
  var theme = _ref10.theme;
  return theme.spacing.sp24;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.spacing.sp24;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.colors.background.success;
});
export var ToastMessage = /*#__PURE__*/styled.div.withConfig({
  displayName: "style__ToastMessage",
  componentId: "sc-1vrc5ye-2"
})(["padding:", ";padding-right:", ";padding-left:", ";b{font-weight:", ";}"], function (_ref13) {
  var theme = _ref13.theme;
  return theme.spacing.sp24;
}, function (_ref14) {
  var dismiss = _ref14.dismiss,
    theme = _ref14.theme;
  return dismiss === 0 ? theme.spacing.sp48 : theme.spacing.sp24;
}, function (_ref15) {
  var alert = _ref15.alert,
    theme = _ref15.theme;
  return alert === 'success' ? theme.spacing.sp48 : theme.spacing.sp24;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.fonts.fontWeight.medium;
});
export var RemoveButton = /*#__PURE__*/styled(Button).withConfig({
  displayName: "style__RemoveButton",
  componentId: "sc-1vrc5ye-3"
})(["padding:0;position:absolute;right:", ";top:", ";svg{fill:black;height:24px;width:24px;}"], function (_ref17) {
  var theme = _ref17.theme;
  return theme.spacing.sp16;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.spacing.sp16;
});
export var StyledResendButton = /*#__PURE__*/styled(Button).withConfig({
  displayName: "style__StyledResendButton",
  componentId: "sc-1vrc5ye-4"
})(["display:flex;padding:", " 0 0 0;"], function (_ref19) {
  var theme = _ref19.theme;
  return theme.spacing.sp16;
});
export var StyledIcon = /*#__PURE__*/styled.span.withConfig({
  displayName: "style__StyledIcon",
  componentId: "sc-1vrc5ye-5"
})(["background-color:", ";border-radius:50px;height:22px;margin-right:", ";width:22px;display:flex;justify-content:center;align-items:center;svg{fill:white;}"], function (_ref20) {
  var theme = _ref20.theme;
  return theme.colors.text.secondary;
}, function (_ref21) {
  var theme = _ref21.theme;
  return theme.spacing.sp8;
});